import { useCombinedAggregates } from "@me8eon/search";

/**
 * Custom hook to retrieve global aggregations by utilizing combined aggregates.
 *
 * This hook leverages the `useCombinedAggregates` function to fetch and manage
 * aggregation data under the key 'aggregations'.
 *
 * @returns {ReturnType<typeof useCombinedAggregates>} The combined aggregation data.
 */
export function useGlobalAggregations() {
    return useCombinedAggregates('aggregations')
}